<template>
  <div class="full-screen-bank-select-page">
    <popup ref="popup"
      fullScreen
      :visible="true"
      :title="gettext('银行名称')">
      <title-bar :title="gettext('银行名称')"
        @back="hide"
        show-back
      ></title-bar>
      <div class="full-screen-bank-select-result">
        <rich-loading v-show="loading"></rich-loading>
        <div class="full-screen-bank-select-scroll-wrap" v-if="!loading">
          <rich-result-page
            type="empty"
            v-show="result.length === 0 && loaded"
          />
          <rich-scroll ref="selectScroll" v-if="result.length > 0">
            <div class="full-screen-bank-select-list-inner-wrap">
              <ul
                class="full-screen-bank-select-list"
              >
                <li
                  class="full-screen-bank-select-list-item"
                  v-for="(item, index) in result"
                  :key="index"
                  :class="{'full-screen-bank-select-list-item-active': activeIndex === index}"
                  @touchstart="touchstart(index)"
                  @touchend="touchend"
                >
                  <rich-cell
                    @click="clickSelectItem(item)"
                    :key="index"
                    :title="item.value"
                  >
                  </rich-cell>
                </li>
                <slot></slot>
              </ul>
            </div>
          </rich-scroll>
        </div>
      </div>
    </popup>
  </div>
</template>
<script>
import popup from './Popup'
import TitleBar from '@/components/TitleBar.vue'
import { getShopCommonConfig } from '@/api'

export default {
  name: 'FullScreenBankSelect',
  components: {
    popup,
    TitleBar
  },
  data () {
    return {
      loading: false,
      loaded: false,
      activeIndex: -1,
      result: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
    },
    init () {
      this.activeIndex = -1
      this.loading = true
      this.loaded = false
      getShopCommonConfig({
        type: 'bankMapFinance',
        withBankList: 1 // 如果为1，表示bank返回的是有序的数组，0返回对象，对象格式为兼容历史版本
      }).then(res => {
        this.result = (res.data || []).map(item => {
          return {
            value: `${item.value} - ${item.key}`,
            key: item.key + ''
          }
        })
        this.initSel(this.result)
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
    initSel (list) {
      this.$emit('initsel', list)
    },
    clickSelectItem (item) {
      this.$emit('select', item)
    },
    touchstart (index) {
      this.activeIndex = index
    },
    touchend () {
      this.activeIndex = -1
    }
  }
}
</script>

<style lang="scss">
.full-screen-bank-select-page {
  overflow: hidden;
  height: 100%;
  position: relative;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
  .rich-loading-spinners {
    margin: 30px auto;
  }
  .full-screen-bank-select-scroll-wrap {
    position: absolute;
    top: 100px;
    bottom: 0;
    width: 100%;
    .full-screen-bank-select-list-inner-wrap {
      padding-bottom: 60px;
    }
  }
  .full-screen-bank-select-list {
    padding: 0 0;
    .rich-cell-title {
      text-align: left;
      .rich-cell-text {
        line-height: 30px;
      }
    }
  }
  .full-screen-bank-select-list-item {
    font-size: 24px;
  }
  .full-screen-bank-select-list-item-active {
    color: #ff7a45;
  }
}
</style>
